import React from 'react';
import { Trans } from '@lingui/react';
import { Variant } from './domain/Terms';
import { PaymentRythm } from '@qover/domain';

import { FormattedCurrency, FormattedMarkdown } from '@qover/react-intl';

export const nextButtonMessages = {
  purchaseNow: <Trans id="bottomNav.purchaseNow" />,
  payNow: <Trans id="bottomNav.payNow" />,
};

// The undefined are only meant for TS_error ...
export const messagesPerVariant = {
  [Variant.VARIANT_BRONZE]: {
    planName: <Trans id="planName.bronze" />,
    planNameKey: 'planName.bronze',
    optionIconLabel: <FormattedMarkdown id="optionLabel.summary.bronze" />,
    optionLabel: <FormattedMarkdown id="optionLabel.bronze" />,
    optionTitle: <Trans id="optionTitle.bronze" />,
    optionContent: <Trans id="optionContent.bronze" />,
    upsellMessage: {
      [PaymentRythm.MONTHLY]: (upsellPrice: number) => (
        <Trans
          id="upsell.bronze"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.YEARLY]: (upsellPrice: number) => (
        <Trans
          id="upsell.bronze.yearly"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.ONE_TIME]: () => undefined,
    },
    optionIcon: undefined,
    dataLayerName: 'Bronze',
    advantages: <FormattedMarkdown id="summary.advantages.bronze" />,
    policyholderText: <FormattedMarkdown id="policyholder.text.bronze" />,
  },
  [Variant.VARIANT_SILVER]: {
    planName: <Trans id="planName.silver" />,
    planNameKey: 'planName.silver',
    optionIconLabel: <FormattedMarkdown id="optionLabel.summary.silver" />,
    optionLabel: <FormattedMarkdown id="optionLabel.silver" />,
    optionTitle: <Trans id="optionTitle.silver" />,
    optionContent: <Trans id="optionContent.silver" />,
    upsellMessage: {
      [PaymentRythm.MONTHLY]: (upsellPrice: number) => (
        <Trans
          id="upsell.silver"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.YEARLY]: (upsellPrice: number) => (
        <Trans
          id="upsell.silver.yearly"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.ONE_TIME]: () => undefined,
    },
    optionIcon: undefined,
    dataLayerName: 'Silver',
    advantages: <FormattedMarkdown id="summary.advantages.silver" />,
    policyholderText: <FormattedMarkdown id="policyholder.text.silver" />,
  },
  [Variant.VARIANT_GOLD]: {
    planName: <Trans id="planName.gold" />,
    planNameKey: 'planName.gold',
    optionIconLabel: <FormattedMarkdown id="optionLabel.summary.gold" />,
    optionLabel: <FormattedMarkdown id="optionLabel.gold" />,
    optionTitle: <Trans id="optionTitle.gold" />,
    optionContent: <Trans id="optionContent.gold" />,
    upsellMessage: {
      [PaymentRythm.MONTHLY]: (upsellPrice: number) => (
        <Trans
          id="upsell.gold"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.YEARLY]: (upsellPrice: number) => (
        <Trans
          id="upsell.gold.yearly"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.ONE_TIME]: () => undefined,
    },
    optionIcon: undefined,
    dataLayerName: 'Gold',
    advantages: <FormattedMarkdown id="summary.advantages.gold" />,
    policyholderText: <FormattedMarkdown id="policyholder.text.gold" />,
  },
};
